module.exports = __webpack_public_path__ + "img/MyAddres.450d8416.svg";